import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import IconControl from './icon-control'
import linkify from '../lib/linkify'

const StyledDiv = styled.div`
  background: ${colours.offWhite};
  color: ${colours.darkBlue};
  border: 1px solid ${colours.grey};
  border-radius: 4px;
  margin-top: 30px;
  margin-bottom: 20px;
  padding: 12px;
  position: relative;
`

const IconContainer = styled.div`
  position: absolute;
`

const StyledLink = linkify(styled.a``)

const Text = styled.div`
  margin-left: 30px;
`

interface IProps {
  href: string
}

const ReturnLinkControl = (props: PropsWithChildren<IProps>) => (
  <StyledDiv>
    <StyledLink href={props.href} target="_blank" rel="noopener noreferrer">
      <IconContainer>
        <IconControl icon="external-link-square-alt" />
      </IconContainer>
      <Text>{props.children}</Text>
    </StyledLink>
  </StyledDiv>
)

export default ReturnLinkControl
